import { observable, action, runInAction } from 'mobx';

export enum NotificationType {
  Info = 'info',
  Error = 'error'
}

export interface Notification {
  duration?: number;
  id?: number;
  message: string;
  type?: NotificationType;
}

export const DEFAULT_NOTIFICATION_DURATION = 3000;

let id = 0;
export class NotificationStore {
  @observable public notifications: Array<Notification> = [];

  @action
  addNotification = (notification: Notification) => {
    notification.type = notification.type || NotificationType.Info;
    notification.duration =
      notification.duration || DEFAULT_NOTIFICATION_DURATION;
    notification.id = notification.id || ++id;

    this.notifications.push(notification);

    // After a delay, remove the notification
    setTimeout(() => {
      const notificationIndex = this.notifications.findIndex(
        existingNotification => existingNotification.id === notification.id
      );

      if (notificationIndex >= 0) {
        runInAction(() => this.notifications.splice(notificationIndex, 1));
      }
    }, notification.duration);
  };
}

export default NotificationStore;



// WEBPACK FOOTER //
// ./src/app/stores/NotificationStore.ts